import { Injector } from "@angular/core";
import { Art57NodeList } from "../../Art57Node/Art57NodeList";
import { ListView } from "../../../Data/ListView";
import { ROAAutoUploadEntity } from "../Entity/ROAAutoUploadEntity";
import { BaseNode } from "../../BaseNode";
import { environment } from "../../../../../../environments/environment";


export class TreeNodeMedicinalProductDrugRoute extends Art57NodeList{
    items: any;
    cloningNode: boolean = false;
    constructor(injector: Injector, parent: any, cloningNode: boolean, items: any[]|undefined) {
        super(injector, new ListView(), `Drug Routes (${items?items.length:'-'})`);
        this.parent = parent;
        this.items = items;
        this.labelNodeName = 'Drug Routes'
        this.cloningNode = cloningNode;

        if (this.cloningNode) {
          return;
        }

        for (const item of items || []) {
            const labelTemplate = `${item.name_Admroute}`;
            this.children?.push(new ROAAutoUploadEntity(injector,labelTemplate,this,item,false, true, false));
                        

        }
    }

    override getHeaders(): string[] {
        return ['Administration Route Name'];
    }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {
      let clonedNode: TreeNodeMedicinalProductDrugRoute = new TreeNodeMedicinalProductDrugRoute(
        this.ioc!,
        newParent,
        true,
        this.items
      );
  
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)


      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
        
      clonedNode.cloningNode = false;
      return clonedNode;
    }

}